/**
 * Collection of task related functions and constants.
 */

// --- Constants ---

/**
 * Task rejection resolvation strategy enumeration.
 *
 * Note: These should be defined in TaskResolvationStrategy enumeration in back-end.
 */
const RESOLVATION_STRATEGY = Object.freeze({
  CANCEL_REJECTION: "CANCEL_REJECTION",
  CHANGE_DOCUMENT: "CHANGE_DOCUMENT",
  CHANGE_DOCUMENT_AND_REVERT_TO_STEP: "CHANGE_DOCUMENT_AND_REVERT_TO_STEP",
  REASSIGN_TO_COLLABORATOR: "REASSIGN_TO_COLLABORATOR",
  REVERT_TO_STEP: "REVERT_TO_STEP",
  SO_REMOVE_SIGNER: "SO_REMOVE_SIGNER",
  SO_REMOVE_SIGNER_AND_CHANGE_DOCUMENT: "SO_REMOVE_SIGNER_AND_CHANGE_DOCUMENT",
  SO_REPLACE_SIGNER:"SO_REPLACE_SIGNER",
  SO_REPLACE_SIGNER_AND_CHANGE_DOCUMENT:"SO_REPLACE_SIGNER_AND_CHANGE_DOCUMENT",
  SKIP_TASK: "SKIP_TASK", // TODO: Consider renaming to "SKIP_STEP".
  RESOLVE_BY_MYSELF: "RESOLVE_BY_MYSELF",
  SIGN_CONFIGURE_MYSELF: "SIGN_CONFIGURE_MYSELF",
  CHANGE_PHONE_NUMBER: "CHANGE_PHONE_NUMBER",
  RESTART_SIGNING_TASK: "RESTART_SIGNING_TASK",
});

/**
 * Task resolving rejection options.
 */
const RESOLVING_OPTION = Object.freeze({
  SELECT_STEP: "SELECT_STEP",
  SELECT_FILE_STEP: "SELECT_FILE_STEP",
  REASSIGN: "REASSIGN",
  RESOLVE_MYSELF: "RESOLVE_MYSELF",
  SIGN_CONFIGURE_MYSELF: "SIGN_CONFIGURE_MYSELF",
  SKIP_TASK: "SKIP_TASK", // TODO: Consider renaming to "SKIP_STEP".
  CHANGE_PHONE_NUMBER: "CHANGE_PHONE_NUMBER",
  RESTART_SIGNING_TASK: "RESTART_SIGNING_TASK",
})

/**
 * Task status enumeration.
 *
 * Note: This should match TaskStatus enumeration in back-end.
 */
const STATUS = Object.freeze({
  AVAILABLE: "AVAILABLE",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  PAUSED: "PAUSED",
  CANCELED: "CANCELED",
  REJECTED: "REJECTED",
  UPCOMING: "UPCOMING"
});


export default {
  // --- Constants ---

  RESOLVATION_STRATEGY,
  STATUS,
  RESOLVING_OPTION,
}
